var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13854 11.009C7.55275 11.009 7.88854 10.6732 7.88854 10.259C7.88854 9.84482 7.55275 9.50903 7.13854 9.50903L2.56045 9.50903L9.79821 2.27127C10.0911 1.97838 10.0911 1.50351 9.79821 1.21061C9.50532 0.917721 9.03045 0.917721 8.73755 1.21061L1.50003 8.44814L1.50003 3.87052C1.50003 3.45631 1.16424 3.12052 0.750028 3.12052C0.335814 3.12052 2.79499e-05 3.45631 2.79862e-05 3.87052L2.85447e-05 10.259C2.85809e-05 10.6732 0.335814 11.009 0.750029 11.009L7.13854 11.009Z",
    fill: "#00BB61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.aa55966a7dac90a1b12e101c4d08db8c.svg";
export { ForwardRef as ReactComponent };